export const iex = {
  api_token: "pk_1b10e95547e74661b25fe0a7f7218349",
  base_url: "https://cloud.iexapis.com/stable",
};
